import React, { createContext, useContext, useState } from 'react';

const DetailContext = createContext(null);

export const DetailProvider = ({ children }) => {
  const [item, setItem] = useState(null);
  const [show, setShow] = useState(null);
  const [freeMovie, setFreeMovie] = useState(null);
  const [freeAutoplay, setFreeAutoplay] = useState(false);
  const open = (it) => { setShow(null); setFreeMovie(null); setItem(it); };
  const close = () => setItem(null);
  const openShow = (s) => { setItem(null); setFreeMovie(null); setShow(s); };
  const closeShow = () => setShow(null);
  const openFree = (m, autoplay = false) => { setItem(null); setShow(null); setFreeAutoplay(autoplay); setFreeMovie(m); };
  const closeFree = () => setFreeMovie(null);
  return (
    <DetailContext.Provider value={{ item, open, close, show, openShow, closeShow, freeMovie, freeAutoplay, openFree, closeFree }}>
      {children}
    </DetailContext.Provider>
  );
};

export const useDetail = () => useContext(DetailContext);
